{
  "workspace": {
    "openDeal": "Open deal",
    "invalidId": "Invalid deal id.",
    "notFound": "This deal workspace isn't available. It may be pending supplier acceptance, or you may no longer be named on it.",
    "loading": "Loading deal workspace…",
    "requestLine": "Request: {{title}}",
    "sideBuyer": "Your side: Buyer",
    "sideSupplier": "Your side: Supplier",
    "sideModerator": "Moderator view",
    "ownerBadge": "Company owner",
    "tabs": {
      "overview": "Overview",
      "files": "Files",
      "tasks": "Tasks",
      "contract": "Contract",
      "costs": "Duty & tax"
    },
    "overview": {
      "title": "Overview",
      "buyer": "Buyer",
      "supplier": "Supplier",
      "outcomeTitle": "Outcome",
      "stageHint": "Companies see the status and stage dates read-only — moderators record them.",
      "timelineTitle": "Timeline",
      "noTimeline": "No milestones recorded yet.",
      "conversationTitle": "Conversation",
      "openConversation": "Open conversation",
      "noConversation": "No conversation on this deal yet."
    },
    "files": {
      "title": "Files",
      "hint": "Files are stored in private storage. Download links expire quickly — refresh the page to generate a new one.",
      "uploading": "Uploading…",
      "empty": "No files shared yet.",
      "download": "Download",
      "delete": "Delete",
      "uploadedBy": "Uploaded by {{name}}",
      "uploadedByModerator": "Uploaded by {{name}} (moderator)",
      "size": "{{size}} bytes",
      "confirmDelete": "Delete this file?"
    },
    "members": {
      "title": "Members",
      "hint": "Owners from both companies always see this deal. Your side's owner can add other users from your company so they share the workspace.",
      "add": "Add member",
      "remove": "Remove",
      "noCandidates": "Everyone from your company is already on this deal.",
      "selectCandidate": "Select a teammate…",
      "ownerSuffix": " (owner)",
      "confirmRemove": "Remove {{name}} from this deal?"
    },
    "tasks": {
      "title": "Tasks",
      "hint": "Moderators create tasks and the daily reminder nags both sides until they're marked done.",
      "empty": "No tasks on this deal.",
      "due": "Due {{date}}",
      "noDueDate": "No due date",
      "statusOpen": "Open",
      "statusDone": "Done",
      "assignee": "Assigned: {{name}}",
      "unassigned": "Unassigned",
      "markDone": "Mark done",
      "reopen": "Reopen",
      "newTask": "New task",
      "savingTask": "Saving task…",
      "titlePlaceholder": "Task title",
      "descriptionPlaceholder": "Description (optional)",
      "save": "Save task",
      "cancel": "Cancel",
      "delete": "Delete",
      "confirmDelete": "Delete this task?"
    },
    "contract": {
      "title": "Contract",
      "none": "No contract on this deal yet. Your moderator will share one when it's ready.",
      "statusLabel": "Status",
      "statusDraft": "Draft",
      "statusActive": "Active",
      "statusAccepted": "Accepted",
      "statusCompleted": "Completed",
      "statusCancelled": "Cancelled",
      "versionLabel": "Current version: v{{version}}",
      "contractType": "Contract type",
      "contractValue": "Contract value",
      "dateSigned": "Date signed",
      "startDate": "Start date",
      "endDate": "End date",
      "description": "Description",
      "terms": "Terms and conditions",
      "documents": "Documents",
      "noDocuments": "No attached documents.",
      "acceptanceTitle": "Acceptance",
      "waitingForBuyer": "Waiting for the buyer's owner to accept.",
      "waitingForSupplier": "Waiting for the supplier's owner to accept.",
      "bothAccepted": "Both parties accepted v{{version}} — this contract is live.",
      "buyerAcceptedAt": "Buyer accepted on {{date}}",
      "supplierAcceptedAt": "Supplier accepted on {{date}}",
      "acceptButton": "Accept this version",
      "accepting": "Accepting…",
      "acceptedByYou": "You've already accepted this version.",
      "notOwnerHint": "Only your company's owner can accept a contract version.",
      "editResetWarning": "Any edit by your moderator after acceptance resets both sides and the new version has to be accepted again.",
      "versionsTitle": "Version history",
      "versionRow": "v{{version}} · saved {{date}}",
      "versionBy": "Saved by {{name}}"
    },
    "errors": {
      "loadDeal": "Failed to load the deal workspace.",
      "loadFiles": "Failed to load files.",
      "loadMembers": "Failed to load members.",
      "loadTasks": "Failed to load tasks.",
      "loadContract": "Failed to load contract.",
      "loadVersions": "Failed to load contract versions.",
      "uploadFile": "Could not upload file.",
      "deleteFile": "Could not delete file.",
      "addMember": "Could not add member.",
      "removeMember": "Could not remove member.",
      "saveTask": "Could not save task.",
      "deleteTask": "Could not delete task.",
      "acceptContract": "Could not accept the contract."
    }
  },
  "shared": {
    "reset": "Reset",
    "assign": "Assign",
    "assigning": "Assigning…",
    "postComment": "Post comment",
    "posting": "Posting…",
    "selectModerator": "Select a moderator…",
    "unassigned": "Unassigned",
    "manualDeal": "Manual deal",
    "superOnly": "Super moderator only.",
    "requestLine": "Request: {{title}}",
    "dealTitle": "Deal #{{id}}",
    "contractStatus": {
      "draft": "Draft",
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled"
    }
  },
  "deals": {
    "title": "Deals",
    "restrictedSubtitle": "All-deals view is super-moderator only.",
    "restrictedBody": "You are signed in as a moderator. Listing every deal across the platform is restricted to super moderators.",
    "subtitle": "Assign moderators, leave comments, and review the deal pipeline.",
    "refreshAria": "Refresh deals",
    "searchPlaceholder": "Search by company name or email",
    "loading": "Loading deals…",
    "loadError": "Failed to load deals.",
    "empty": "No deals.",
    "assignFailed": "Assign failed.",
    "commentFailed": "Comment failed.",
    "row": {
      "parties": "Requester: <strong>{{requester}}</strong> · Matched: <strong>{{matched}}</strong>",
      "scores": "Score: <strong>{{score}}</strong> · Industry {{industry}} · Compliance {{compliance}} · Geo {{geo}} · Export {{exportExperience}}",
      "assigned": "Assigned: {{name}}",
      "outcome": "Outcome: {{label}}",
      "contract": "Contract: {{reference}}",
      "comments_one": "{{count}} comment",
      "comments_other": "{{count}} comments",
      "assignHeading": "Assign moderator",
      "commentHeading": "Add comment",
      "commentPlaceholder": "Notes for other moderators…",
      "open": "Open",
      "manage": "Manage"
    }
  },
  "dealDetail": {
    "invalidId": "Invalid deal id.",
    "loadError": "Failed to load deal.",
    "back": "← Back",
    "overview": "Overview",
    "requester": "Requester:",
    "matched": "Matched:",
    "supplierConsent": "Supplier consent:",
    "declineReason": "Decline reason: {{reason}}",
    "manualReason": "Reason: {{reason}}",
    "scores": {
      "winWin": "Win-Win",
      "industry": "Industry",
      "compliance": "Compliance",
      "geo": "Geo",
      "export": "Export"
    },
    "explanationTitle": "Why this match (engine breakdown)",
    "assignment": {
      "title": "Assignment",
      "current": "Currently assigned to: <strong>{{name}}</strong>",
      "superOnly": "Reassignment is super-moderator only."
    },
    "comments": {
      "title": "Comments ({{count}})",
      "moderatorFallback": "Moderator",
      "placeholder": "Add a comment…"
    },
    "timeline": {
      "title": "Timeline",
      "hint": "Advance the deal through the canonical milestones.",
      "status": {
        "pending": "Pending",
        "done": "Done",
        "not_done": "Not done"
      }
    },
    "contract": {
      "title": "Contract",
      "edit": "Edit contract",
      "create": "Create contract",
      "new": "New contract",
      "reference": "Reference: {{reference}} · ",
      "none": "No contract on this deal yet.",
      "typeRequired": "Contract type is required.",
      "saveFailed": "Save failed. Check the fields and try again.",
      "fields": {
        "type": "Contract type",
        "status": "Status",
        "value": "Contract value",
        "dateSigned": "Date signed",
        "startDate": "Start date",
        "endDate": "End date",
        "description": "Description",
        "terms": "Terms and conditions",
        "documents": "Document URLs (one per line)",
        "documentsHint": "Paste S3 / signed URLs. Upload via /common/upload/ first."
      }
    }
  },
  "outcomeCard": {
    "title": "Outcome",
    "edit": "Edit outcome",
    "reason": " · Reason: {{reason}}",
    "updated": " · Updated {{date}}",
    "internalNote": "Internal note: {{note}}",
    "stages": "Match accepted: {{matchAccepted}} · First meeting: {{firstMeeting}} · Proposal: {{proposal}} · Contract signed: {{contractSigned}}",
    "lostOn": " · Lost: {{date}}",
    "attributionLabel": "Success-fee attribution:",
    "attributed": "Attributed to MatchPoint · Won {{date}}",
    "notAttributed": "Not attributed · Won {{date}}",
    "attributionPending": "recorded when the deal is won",
    "value": " · Value {{value}} {{currency}}",
    "visibility": "Companies see the status and stage dates, never the reason or note.",
    "errors": {
      "reasonRequired": "Choose a reason for the lost deal.",
      "currencyRequired": "Enter the currency of the deal value.",
      "saveFailed": "Save failed. Check the fields and try again."
    },
    "fields": {
      "status": "Status",
      "reasonRequired": "Reason (required)",
      "selectReason": "Select a reason…",
      "firstMeeting": "First meeting held",
      "proposal": "Proposal / negotiation",
      "contractSigned": "Contract signed",
      "contractSignedHint": "Defaults to today when the deal is marked won.",
      "lostOn": "Lost on",
      "lostOnHint": "Defaults to today.",
      "noteRequiredForOther": "Internal note (required for Other)",
      "noteOptional": "Internal note (optional)",
      "noteHint": "Moderators only.",
      "dealValue": "Deal value (optional)",
      "currency": "Currency",
      "attributed": "Attributed to MatchPoint (success fee)"
    },
    "save": "Save outcome"
  },
  "manualDeal": {
    "title": "Create manual deal",
    "intro": "Only for companies that were never matched. Manual deals are flagged in moderator lists and reporting and are not attributed to MatchPoint by default. Both companies must be approved.",
    "buyer": "Buyer",
    "supplier": "Supplier",
    "selectCompany": "Select a company…",
    "reason": "Reason (required)",
    "reasonPlaceholder": "For example: introduced at a trade mission before either company joined",
    "dealTitle": "Deal title (optional)",
    "creating": "Creating…",
    "errors": {
      "pickBoth": "Pick the buyer and the supplier.",
      "pickDifferent": "Pick two different companies.",
      "reasonRequired": "A reason is required for a manual deal.",
      "createFailed": "Could not create the manual deal."
    }
  },
  "contracts": {
    "title": "My contracts",
    "subtitle": "Contracts created by you, with status filtering and search.",
    "createFromDeal": "Create from a deal",
    "searchPlaceholder": "Search by counterpart company name",
    "allStatuses": "All statuses",
    "loading": "Loading contracts…",
    "loadError": "Failed to load contracts.",
    "empty": "No contracts.",
    "cardTitle": "Contract #{{id}}"
  },
  "conversations": {
    "title": "Conversations",
    "subtitle": "Direct conversations with companies. Open one to read or reply.",
    "searchPlaceholder": "Search company name or message",
    "loadError": "Failed to load.",
    "empty": "No conversations.",
    "fallbackName": "Conv #{{id}}",
    "noMessagesYet": "No messages yet",
    "selectPrompt": "Select a conversation to view its messages.",
    "loadingMessages": "Loading messages…",
    "noMessages": "No messages yet.",
    "you": "You",
    "company": "Company",
    "replyPlaceholder": "Write a reply…"
  },
  "matching": {
    "title": "Matching Engine",
    "restricted": "The matching engine settings are restricted to super moderators.",
    "subtitle": "Tune the global scoring weights and dry-run queries against the live catalog without persisting any deals.",
    "pipelineRuns": "Pipeline runs",
    "settings": {
      "title": "Engine Settings",
      "hint": "Changes apply to every match request created after save. The singleton is auto-created with sane defaults.",
      "loading": "Loading settings…",
      "empty": "No settings yet.",
      "discard": "Discard",
      "structuredHint": "Within the structured component",
      "cosine": "Cosine weight",
      "cosineHint": "0 = pure structured, 1 = pure semantic",
      "quantity": "Quantity weight",
      "price": "Price weight",
      "deliveryTime": "Delivery-time weight",
      "topK": "Top K",
      "topKHint": "Candidates returned per match request (1–100)",
      "minScore": "Min score threshold",
      "minScoreHint": "Drop candidates below this final score (0 keeps all)"
    },
    "playground": {
      "title": "Playground",
      "hint": "Run a query against the live vector store. Per-call weight overrides take precedence; missing fields fall back to the settings above. Nothing is persisted.",
      "query": "Query",
      "queryPlaceholder": "Aluminum sheets for aerospace, 2mm corrosion-resistant...",
      "type": "Type",
      "product": "Product",
      "service": "Service",
      "region": "Region",
      "regionPlaceholder": "e.g. Germany",
      "quantity": "Quantity",
      "price": "Price",
      "deliveryTime": "Delivery time",
      "deliveryPlaceholder": "e.g. 7-14 days",
      "overrides": "Per-call overrides (leave blank to use settings)",
      "override": {
        "cosine": "cosine",
        "quantity": "quantity",
        "price": "price",
        "delivery": "delivery",
        "topK": "topK"
      },
      "searching": "Searching…",
      "run": "Run query",
      "candidates_one": "{{count}} candidate",
      "candidates_other": "{{count}} candidates",
      "error": "Search failed. Check the OpenAI key and ChromaDB availability.",
      "noMatches": "No matches for that query against the current catalog.",
      "table": {
        "rank": "Rank",
        "supplier": "Supplier",
        "product": "Product",
        "final": "Final",
        "cosine": "Cosine",
        "structured": "Structured",
        "region": "Region"
      }
    }
  },
  "pipeline": {
    "durationMs": "{{value}} ms",
    "durationS": "{{value}} s",
    "stage": {
      "started": "Started",
      "query_embedded": "Query embedded",
      "vector_search": "Vector search",
      "ranking": "Ranking",
      "threshold_filter": "Threshold filter",
      "persisted": "Persisted",
      "completed": "Completed",
      "failed": "Failed"
    }
  },
  "runs": {
    "title": "Pipeline Runs",
    "restricted": "Listing matching pipeline runs is restricted to super moderators.",
    "subtitle": "Stage-level audit log of every match request the engine has processed. Click a row to drill into the event timeline.",
    "engineSettings": "Engine settings",
    "refreshAria": "Refresh runs",
    "activity": {
      "title": "Activity",
      "hint": "Counters across the last 7 and 30 days.",
      "last7": "Last 7 days",
      "last30": "Last 30 days",
      "runs": "Runs",
      "successful": "Successful",
      "failed": "Failed",
      "avgDuration": "Avg duration"
    },
    "scores": {
      "title": "Score distribution",
      "hint": "Combined score of every ranked candidate over the last {{days}} days. Results below the minimum score ({{threshold}}) are not shown to companies. Use this, with moderator judgement of match quality, to calibrate the threshold (MATCHING_MIN_SCORE / min score setting).",
      "candidates": "Candidates",
      "aboveMinimum": "Above minimum",
      "envMinimum": "Env minimum",
      "moderatorMinimum": "Moderator minimum",
      "histogramAria": "Candidate score histogram",
      "bucket": "{{lower}}–{{upper}}: {{count}}"
    },
    "list": {
      "title": "Runs",
      "hint": "Filter by status or requester company.",
      "status": "Status",
      "companyId": "Company ID",
      "companyIdPlaceholder": "e.g. 42",
      "loading": "Loading runs…",
      "loadError": "Failed to load runs.",
      "empty": "No matching pipeline runs in scope. Once a buyer creates a non-draft match request, it'll show up here.",
      "statusOption": {
        "all": "All",
        "completed": "Completed",
        "failed": "Failed",
        "working": "Working",
        "pending": "Pending"
      },
      "table": {
        "run": "Run",
        "requester": "Requester",
        "status": "Status",
        "lastStage": "Last stage",
        "events": "Events",
        "duration": "Duration",
        "created": "Created",
        "actions": "Actions"
      },
      "matchRequestFallback": "Match request #{{id}}",
      "companyRef": "co. #{{id}}",
      "detail": "Detail"
    }
  },
  "runDetail": {
    "title": "Pipeline Run",
    "restricted": "This page is restricted to super moderators.",
    "backToRuns": "Back to runs",
    "runFallback": "Run #{{id}}",
    "subtitle": "Stage-level audit trail of the matching pipeline for this match request.",
    "loading": "Loading run…",
    "loadError": "Failed to load run.",
    "notFound": "Run not found.",
    "summary": {
      "title": "Summary",
      "hint": "Snapshot of the underlying match request.",
      "matchRequestId": "Match request ID",
      "status": "Status",
      "created": "Created",
      "requesterCompany": "Requester company",
      "requesterCompanyId": "Requester company ID",
      "events": "Events"
    },
    "whyFailed": "<strong>Why it failed</strong>: {{reason}}",
    "noReason": "No reason recorded.",
    "retrying": "Retrying…",
    "retry": "Retry matching",
    "retryFailed": "Retry failed. Check the event timeline.",
    "timeline": {
      "title": "Event timeline",
      "hint": "Each row is one stage of the pipeline. Metadata blobs come straight from the backend audit log.",
      "empty": "No events recorded. This usually means the match request pre-dates the audit log."
    },
    "errorFallback": "Error"
  },
  "sourceBreakdown": {
    "title": "Companies by source",
    "titleWithTotal": "Companies by source ({{total}})",
    "loadError": "Could not load source counts.",
    "type": "Type",
    "companies": "Companies",
    "namedSource": "Named source",
    "inactive": "{{name}} (inactive)",
    "sourceType": {
      "institution": "Institution",
      "event": "Event",
      "partner": "Partner",
      "other": "Other",
      "unknown": "Unknown"
    }
  },
  "coordinator": {
    "draftStatus": {
      "pending": "Waiting for approval",
      "approved": "Approved and sent",
      "rejected": "Rejected"
    },
    "recipient": {
      "buyer": "buyer",
      "supplier": "supplier"
    },
    "channel": {
      "message": "Moderator message",
      "notification": "Notification"
    },
    "source": {
      "agent": "Drafted by the coordinator",
      "stall_rule": "Stalled-deal reminder",
      "moderator": "Written by a moderator"
    },
    "minutes_one": "{{count}} min",
    "minutes_other": "{{count}} min",
    "hoursMinutes": "{{hours}} h {{minutes}} min",
    "draft": {
      "to": "To {{company}} ({{role}})",
      "deal": "Deal #{{id}} · {{title}}",
      "textLabel": "Text (edit before approving)",
      "logTime": "Log my review time (minutes):",
      "approve": "Approve and send",
      "approving": "Sending…",
      "reject": "Reject",
      "rejectReason": "Reason (optional, internal)",
      "confirmReject": "Confirm reject",
      "approvalNote": "Nothing reaches the company until you approve. Messages are sent from you in your conversation with the company.",
      "approvedBy": "Approved by {{name}} on {{date}}.",
      "rejectedBy": "Rejected by {{name}} on {{date}}.",
      "edited": "Edited before sending.",
      "reason": "Reason: {{reason}}",
      "errors": {
        "empty": "The text cannot be empty.",
        "approveFailed": "Could not approve the draft.",
        "rejectFailed": "Could not reject the draft."
      }
    },
    "panel": {
      "title": "Deal coordinator",
      "internalOnly": "Internal to MatchPoint moderators — never shown to the companies.",
      "loadError": "Could not load the coordinator panel.",
      "pendingDrafts_one": "{{count}} draft waiting for approval",
      "pendingDrafts_other": "{{count}} drafts waiting for approval",
      "noDrafts": "No drafts waiting for this deal.",
      "reviewedDrafts_one": "{{count}} reviewed draft",
      "reviewedDrafts_other": "{{count}} reviewed drafts"
    },
    "timeLog": {
      "title": "Moderator time on this deal: {{total}}",
      "minutesLabel": "Minutes",
      "dateLabel": "Date (default today)",
      "noteLabel": "Note (optional)",
      "add": "Log time",
      "empty": "No time logged yet.",
      "columns": {
        "date": "Date",
        "moderator": "Moderator",
        "minutes": "Minutes",
        "note": "Note"
      },
      "errors": {
        "minutes": "Enter whole minutes between 1 and 1440.",
        "saveFailed": "Could not log the time."
      }
    },
    "queue": {
      "title": "Coordinator queue",
      "subtitle": "Follow-ups and reminders drafted for your deals. Edit, then approve to send — or reject.",
      "statusFilter": "Show",
      "all": "All",
      "loadError": "Could not load the queue.",
      "empty": "Nothing in the queue.",
      "page": "Page {{page}} of {{pages}}"
    },
    "notConfigured": "The coordinator's AI features are not configured (no language-model key). Summaries, next steps and AI follow-up drafts are unavailable; the queue, stall scan and time log still work.",
    "notConfiguredQueue": "AI drafting is not configured. Stalled-deal reminders and the queue still work.",
    "insights": {
      "summaryTitle": "Thread summary",
      "summarize": "Summarise",
      "refreshSummary": "Refresh summary",
      "noSummary": "No summary yet.",
      "nextStepsTitle": "Suggested next steps",
      "suggest": "Suggest next steps",
      "noNextSteps": "No suggestions yet.",
      "generated": "Generated {{date}} by {{name}}.",
      "working": "Working…",
      "followUpTitle": "Draft a follow-up",
      "to": {
        "buyer": "To the buyer",
        "supplier": "To the supplier"
      },
      "guidance": "Guidance for the draft (optional)",
      "draftFollowUp": "Draft follow-up",
      "followUpNote": "Drafts go to the approval queue below — nothing is sent until you approve.",
      "drafted_one": "{{count}} draft added to the queue.",
      "drafted_other": "{{count}} drafts added to the queue.",
      "model": "Model: {{model}}",
      "errors": {
        "noRecipient": "Choose at least one company.",
        "summaryFailed": "Could not summarise the deal.",
        "nextStepsFailed": "Could not suggest next steps.",
        "draftFailed": "Could not draft a follow-up.",
        "llmFailed": "The coordinator could not get an answer from the language model. Try again later."
      }
    },
    "stall": {
      "title_one": "{{count}} stalled deal",
      "title_other": "{{count}} stalled deals",
      "autoDraft": "Queue reminder drafts for newly stalled deals",
      "runScan": "Run stall scan",
      "scanning": "Scanning…",
      "thresholds": "Rules: supplier hasn't answered for over {{consent}} days · no messages for over {{messages}} days · no stage change for over {{stage}} days (open deals only).",
      "result": "Scanned {{scanned}} deals: {{flagged}} newly stalled, {{still}} still stalled, {{resolved}} resolved, {{drafts}} reminder drafts queued.",
      "empty": "No stalled deals. Run the scan to check.",
      "dealFlagged": "This deal looks stalled:",
      "since": "flagged {{date}}",
      "columns": {
        "deal": "Deal",
        "parties": "Buyer ↔ Supplier",
        "reason": "Why",
        "moderator": "Moderator",
        "flagged": "Flagged"
      },
      "rules": {
        "pending_consent_one": "Supplier hasn't answered the match for {{count}} day",
        "pending_consent_other": "Supplier hasn't answered the match for {{count}} days",
        "no_messages_one": "No messages between the companies for {{count}} day",
        "no_messages_other": "No messages between the companies for {{count}} days",
        "no_stage_change_one": "No stage change for {{count}} day",
        "no_stage_change_other": "No stage change for {{count}} days"
      },
      "errors": {
        "scanFailed": "The stall scan failed."
      }
    }
  }
}
